module.exports = __webpack_public_path__ + "static/media/pediatrica.d7614edf.svg";